module.exports = __webpack_public_path__ + "static/media/robotGroupAvatar.39a2398e.svg";